import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";

export const royalkalusteetCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			projectEnabled: false,
			configuratorEnabled: true,
			purchaseEnabled: false,
			manufacturingEnabled: false,
			warehouseInventoryEnabled: false,
			vectorEmbeddingsEnabled: true,
		},
		spc: {
			enabled: false,
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
	},
};
